import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {BaseMenuItemInventoryComponent} from '../base-menu-item-inventory.component';
import {OrganizationRewardProgram} from '../../_models/organization-reward-program';
import {UserOrganizationCreditSummary} from '../../_models/user-organization-credit-summary';
import {MenuCategoryItem} from '../../_models/menu-category-item';
import {MenuItemInventoryService} from '../../_services/menu-item-inventory.service';
import {OrganizationTerminalService} from '../../_services/organization-terminal.service';
import {ModalController} from '@ionic/angular';
import {Membership} from '../../_models/membership';
import {MembershipService} from '../../_services/membership.service';
import {Organization} from '../../_models/organization';
import {OrganizationService} from '../../_services/organization.service';
import {OrderService} from '../../_services/order.service';
import {Order} from '../../_models/order';
import {Constants} from '../../_constants/constants';
import {PickupLocationMenuService} from '../../_services/pickup-location-menu.service';

@Component({
    selector: 'bb-mobile-menu-item',
    templateUrl: './mobile-menu-item.component.html',
    styleUrls: ['./mobile-menu-item.component.scss'],
})
export class MobileMenuItemComponent extends BaseMenuItemInventoryComponent implements OnInit, OnChanges {
    @Input() terminalMode = false;
    @Input() screenWidth: number;
    @Input() item: MenuCategoryItem;
    @Input() rewardProgram: OrganizationRewardProgram;
    @Input() activeCredit: UserOrganizationCreditSummary;
    @Input() showInventory = false;
    @Input() color = '#ECECEC';
    @Input() organization: Organization;
    @Input() activeMembership: Membership;
    @Input() order: Order;
    @Input() contrastColor = '#000000';
    @Output() openItemModal = new EventEmitter();

    showImages = true;

    minToken: number;
    maxToken: number;
    availableTokens = 0;

    protected readonly Constants = Constants;

    constructor(
        modalController: ModalController,
        menuItemInventoryService: MenuItemInventoryService,
        organizationTerminalService: OrganizationTerminalService,
        private pickupLocationMenuService: PickupLocationMenuService,
        private membershipService: MembershipService,
        private orderService: OrderService,
        private organizationService: OrganizationService
    ) {
        super(modalController, menuItemInventoryService, organizationTerminalService);
    }

    ngOnInit() {
        this.menuItem = this.item.menuItem;
        this.showImages = this.pickupLocationMenuService.showImagesCurrent;

        if (!!this.menuItem && !!this.menuItem.prices && this.menuItem.prices.length === 1) {
            this.menuItemPrice = this.menuItem.prices[0];
        }
        super.ngOnInit();

        this.subscribe(this.pickupLocationMenuService.showImages.subscribe(s => this.showImages = s));

        this.checkTokenOptions();
    }

    ngOnChanges(changes: SimpleChanges) {
        if ((!!changes.organization && !changes.organization.firstChange)
            || (!!changes.order && !changes.order.firstChange)
            || (!!changes.activeMembership && !changes.activeMembership.firstChange)) {
            this.checkTokenOptions();
        }
    }

    checkTokenOptions() {
        if (!!this.organization && !!this.organization.tokenGroups && this.organization.tokenGroups.length > 0) {
            this.availableTokens = (!!this.activeMembership ? this.activeMembership.availableTokens : 0)
                - (!!this.order ? this.order.tokenPayments() : 0);

            if (!!this.activeMembership
                && !!this.availableTokens
                && !!this.activeMembership.activeMembershipProgram
                && !!this.organization.tokenGroups) {
                const tokenGroups = this.organization.tokenGroups
                    .filter(g => g.items.some(i => i.itemId === this.menuItem.id));

                this.minToken = null;
                this.maxToken = null;

                tokenGroups.forEach(t => {
                    const tokenAvailability = !!this.activeMembership.availableTokenGroups
                        ? this.activeMembership.availableTokenGroups.find(ta => ta.id === t.id)
                        : null;

                    if (!!tokenAvailability &&
                        (!tokenAvailability.remaining
                            || tokenAvailability.remaining > tokenAvailability.currentUsed)) {
                        this.minToken = !this.minToken || t.tokenCount < this.minToken ? t.tokenCount : this.minToken;
                        this.maxToken = this.availableTokens >= t.tokenCount && (!this.maxToken || t.tokenCount > this.maxToken)
                            ? t.tokenCount
                            : this.maxToken;
                    } else {
                        this.minToken = null;
                        this.maxToken = null;
                    }
                });
            } else {
                this.minToken = null;
                this.maxToken = null;
            }
        }
    }
}
